import { axiosV3 } from '@/helpers/_core/axios';

export default class AuthV3 {
  static SERVICE_NAME = 'authV3';

  constructor({ app }) {
    this.axios = axiosV3(app);
  }

  /**
   * @param {{
   *   refreshToken: string,
   *   username?: string,
   *   userId?: string
   * }} body
   * @returns {Promise<any>}
   */
  async impersonate(body) {
    return this.axios
      .default().post('/auth/impersonate', body)
      .then(r => r.data);
  }

  async exchangeLegacyToken(tokenId) {
    return this.axios
      .default().get('/auth/sso/legacy/exchange', {
        headers: {
          'Authorization': tokenId
        },
        withCredentials: true
      })
      .then(r => r.data);
  }
}
